import React from 'react';
import PropTypes from 'prop-types';
import { Panel, FormGroup, FormControl } from 'react-bootstrap';

import { reorderableList } from 'helpers/react_dnd/reorderable_list';
import DefaultPageRow from './default_page_row';

export class DefaultPages extends React.Component {
  static propTypes = {
    availablePages: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired
    })).isRequired,
    defaultPages: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number.isRequired,
      key: PropTypes.string.isRequired
    })),
    onRemovePage: PropTypes.func.isRequired,
    onReorderPage: PropTypes.func.isRequired
  }

  render() {
    // The prop may be null if the template was created via duplication
    const defaultPages = this.props.defaultPages || [];

    return (
      <div>
        <div className="my-3">
          <strong>Page Defaults</strong> | Click and drag pages to reorder
        </div>
        <p className="my-3">
          The pages that will populate into the "Pages" section of the document editor
        </p>

        {/* Non functional - Needed for spacing alignment */}
        <FormGroup className="search-container invisible">
          <FormControl type="text" />
        </FormGroup>

        <Panel>
          <ul className="list-group overflow-auto" style={{ maxHeight: '300px' }}>
            {defaultPages.map((defaultPage, index) => (
              <DefaultPageRow
                index={index}
                key={defaultPage.key}
                page={this.props.availablePages.find(availablePage => availablePage.id === defaultPage.id)}
                onRemovePage={this.props.onRemovePage}
                onReorder={this.props.onReorderPage}
              />
            ))}
            {defaultPages.length === 0 && (
              <Panel.Body>
                <div className="text-center text-muted">
                  Using the default set of pages
                </div>
              </Panel.Body>
            )}
          </ul>
        </Panel>
      </div>
    );
  }
}

export default reorderableList(DefaultPages);
